import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { FiduciaryModalComponent } from './fiduciary-modal.component';
import { Fiduciary } from '../../../core/data/clients/fiduciary.model';

@Component({
  selector: 'app-fiduciary-form',
  templateUrl: './fiduciaries.component.html',
})
export class FiduciariesComponent {
  private _fiduciaries: Fiduciary[];

  @Input()
  set fiduciaries(fiduciaries: Fiduciary[]) {
    this._fiduciaries = fiduciaries || [];
  }

  get fiduciaries(): Fiduciary[] {
    return this._fiduciaries;
  }

  @Output() onChange = new EventEmitter<Fiduciary[]>();
  @ViewChild(FiduciaryModalComponent) private fiduciaryModal;

  printNotifications(notifications: string[]) {
    return notifications
      .map((type: string) => type === 'standard' ? 'Recipient Tax Invoice' : 'Tax Invoice')
      .join(', ');
  }

  openFiduciaryModal(fiduciary?: Fiduciary) {
    this.fiduciaryModal.open(fiduciary);
  }

  removeFiduciary(id: string) {
    if (confirm('Are you sure you want to delete this address?')) {
      this.emit(this.fiduciaries.filter((fiduciary: Fiduciary) => fiduciary.id !== id));
    }
  }

  saveFiduciary(fiduciary: Fiduciary) {
    this.emit(fiduciary.id !== null
      ? this.fiduciaries.map((f: Fiduciary) => f.id === fiduciary.id ? fiduciary : f)
      : [...this.fiduciaries, fiduciary]);

    this.fiduciaryModal.close();
  }

  emit(output: Fiduciary[]) {
    this.onChange.emit(output);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/fiduciaries/fiduciaries.component.ts